import { createBroker } from 'broker-factory';
/*
 * @todo Explicitly referencing the barrel file seems to be necessary when enabling the
 * isolatedModules compiler option.
 */
export * from './interfaces/index';
export * from './types/index';
export const wrap = createBroker({
    parseArrayBuffer: ({ call }) => {
        return async (arrayBuffer) => {
            return call('parse', { arrayBuffer }, [arrayBuffer]);
        };
    }
});
export const load = (url) => {
    const worker = new Worker(url);
    return wrap(worker);
};
//# sourceMappingURL=/build/es2019/module.js.map